import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withKeys as _withKeys, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "col-12 col-sm-6 col-md-4 s-filter--elem" }
const _hoisted_2 = { class: "col-12 col-sm-6 col-md-4 s-filter--elem" }
const _hoisted_3 = { class: "col-12 col-sm-6 col-md-4 s-filter--elem" }
const _hoisted_4 = { class: "row justify-center s-mb-xl" }
const _hoisted_5 = { class: "col-xs-12" }
const _hoisted_6 = { class: "s-mb-xl" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "flex flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_input = _resolveComponent("s-input")!
  const _component_s_input_date = _resolveComponent("s-input-date")!
  const _component_filters = _resolveComponent("filters")!
  const _component_s_icon = _resolveComponent("s-icon")!
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_news_skeleton_item = _resolveComponent("news-skeleton-item")!
  const _component_news_item = _resolveComponent("news-item")!
  const _component_not_found_data = _resolveComponent("not-found-data")!
  const _component_q_pagination = _resolveComponent("q-pagination")!
  const _component_s_page = _resolveComponent("s-page")!

  return (_openBlock(), _createBlock(_component_s_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_filters, {
        modelValue: _ctx.filterParams,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterParams) = $event)),
        class: "s-mb-xl s-card",
        "default-filters": _ctx.defaultFilterParams(),
        onApplyFilter: _ctx.applyFilter
      }, {
        default: _withCtx(({ filters }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_s_input, {
              modelValue: filters.source,
              "onUpdate:modelValue": ($event: any) => ((filters.source) = $event),
              modelModifiers: { trim: true },
              label: "Источник",
              class: "s-form-input_wrapper",
              dense: "",
              clearable: "",
              onClear: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearFilterParam('source')))
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_s_input_date, {
              modelValue: filters.fromDate,
              "onUpdate:modelValue": ($event: any) => ((filters.fromDate) = $event),
              class: "s-form-input_wrapper",
              label: "Дата начала",
              dense: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_s_input_date, {
              modelValue: filters.toDate,
              "onUpdate:modelValue": ($event: any) => ((filters.toDate) = $event),
              class: "s-form-input_wrapper",
              label: "Дата окончания",
              dense: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "default-filters", "onApplyFilter"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_s_input, {
                key: 0,
                modelValue: _ctx.filterParams.title,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterParams.title) = $event)),
                modelModifiers: { trim: true },
                clearable: "",
                label: "Поиск новости по названию",
                class: "s-input--main_search",
                onClear: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clearFilterParam('title'))),
                onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.applyFilter()), ["enter"]))
              }, _createSlots({
                prepend: _withCtx(() => [
                  _createVNode(_component_s_icon, { name: "app:search" })
                ]),
                _: 2
              }, [
                (!_ctx.isMobile)
                  ? {
                      name: "append",
                      fn: _withCtx(() => [
                        _createVNode(_component_s_btn, {
                          label: "Поиск новости",
                          loading: _ctx.showLoading,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.applyFilter()))
                        }, null, 8, ["loading"])
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["modelValue"]))
            : (_openBlock(), _createBlock(_component_q_skeleton, {
                key: 1,
                class: "s-skeleton",
                type: "QRange",
                animation: "fade"
              }))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.isLoading || (_ctx.showLoading && _ctx.newsList.length === 0))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["row news__wrapper q-col-gutter-sm", {
          'q-col-gutter-sm': _ctx.isMobile,
          'q-col-gutter-md': _ctx.isLaptop,
          'q-col-gutter-lg': _ctx.isDesktop,
        }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.random([9, 12]), (_, k) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: k,
                  class: "col-xs-12 col-sm-6 col-md-4 row news__item-wrapper"
                }, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_news_skeleton_item, {
                        key: 0,
                        class: "col-xs-12"
                      }))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ], 2))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["row news__wrapper q-col-gutter-sm", {
          'q-col-gutter-sm': _ctx.isMobile,
          'q-col-gutter-md': _ctx.isLaptop,
          'q-col-gutter-lg': _ctx.isDesktop,
        }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsList, (news, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col-xs-12 col-sm-6 col-md-4 row news__item-wrapper"
            }, [
              _createVNode(_component_news_item, {
                class: "col-xs-12 full-height",
                news: news,
                "icon-number": index
              }, null, 8, ["news", "icon-number"])
            ]))
          }), 128))
        ], 2), [
          [_vShow, !_ctx.isLoading]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (!_ctx.isLoading && _ctx.newsList.length === 0)
          ? (_openBlock(), _createBlock(_component_not_found_data, {
              key: 0,
              class: "col-xs-12 offset-xs-0 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-8 offset-lg-2"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.pagination.rowsPerPage && _ctx.maxPagePagination > 1)
          ? (_openBlock(), _createBlock(_component_q_pagination, {
              key: 0,
              modelValue: _ctx.pagination.page,
              "onUpdate:modelValue": [
                _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pagination.page) = $event)),
                _ctx.proxyInputPagination
              ],
              color: "brand",
              max: _ctx.maxPagePagination,
              "max-pages": 5,
              "boundary-numbers": ""
            }, null, 8, ["modelValue", "max", "onUpdate:modelValue"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}